// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.valour_wrapper {
  width: 100%;
  height: 498px;
  position: relative;
  margin: 100px 0 137px 0;
  overflow: hidden;
}

.valour_slider_main {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  outline: none;
}

.valour_card {
  width: 100%;
  height: 100% !important;
}

.valour_card > img {
  width: 100%;
  height: 498px;
  outline: none;
  object-fit: cover;
}

.valour_overlay {
  width: 100% !important;
  height: 100%;
  object-fit: cover;
  position: absolute;
  z-index: 2;
}

.valpour_text_div {
  width: 100% !important;
  height: 100%;
  position: absolute;
  z-index: 3;
  display: flex;
  align-items: center !important;
}

.valour_text_inner_div {
    width: 591px;
    margin-left: 60px;
}

.valour_text_1 {
  color: #fff;
  font-family: Inter;
  font-size: 52px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.valour_text_2 {
  color: #139719;
  font-family: "Open Sans";
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 10px 0 24px 0;
}

.valour_text_3 {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Open Sans";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 38.4px; /* 160% */
}










@media screen and (max-width: 1200px) {

  .valour_wrapper {
    width: 100%;
    height: 450px;
    margin: 50px 0 50px 0;
  }
  
  .valour_slider_main {
    width: 100%;
    height: 100%;
  }

  .valour_card > img {
    height: 450px;
  }
  
  .valpour_text_div {
    width: 100% !important;
    height: 100%;
  }
  
  .valour_text_inner_div {
      width: 50%;
      margin-left: 60px;
  }
  
  .valour_text_1 {
    font-size: 50px;
    line-height: 56px;
  }
  
  .valour_text_2 {
    font-size: 26px;
    line-height: 32px;
    margin: 10px 0 16px 0;
  }
  
  .valour_text_3 {
    font-size: 24px;
    line-height: 30px; /* 160% */
  }  

}












@media screen and (max-width: 1024px) {

  .valour_wrapper {
    width: 100%;
    height: 400px;
    margin: 50px 0 50px 0;
  }
  
  .valour_slider_main {
    width: 100%;
    height: 100%;
  }

  .valour_card > img {
    height: 400px;
  }
  
  .valpour_text_div {
    width: 100% !important;
    height: 100%;
  }
  
  .valour_text_inner_div {
      width: 50%;
      margin-left: 20px;
  }
  
  .valour_text_1 {
    font-size: 40px;
    line-height: 46px;
  }
  
  .valour_text_2 {
    font-size: 22px;
    line-height: 26px;
    margin: 4px 0 6px 0;
  }
  
  .valour_text_3 {
    font-size: 22px;
    line-height: 26px; /* 160% */
  }  

}














@media screen and (max-width: 800px) {

  .valour_wrapper {
    width: 100%;
    height: 320px;
    margin: 50px 0 50px 0;
  }
  
  .valour_slider_main {
    width: 100%;
    height: 100%;
  }

  .valour_card > img {
    height: 320px;
  }
  
  .valpour_text_div {
    width: 100% !important;
    height: 100%;
  }
  
  .valour_text_inner_div {
      width: 70%;
      margin-left: 20px;
  }
  
  .valour_text_1 {
    font-size: 36px;
    line-height: 42px;
  }
  
  .valour_text_2 {
    font-size: 20px;
    line-height: 24px;
    margin: 4px 0 6px 0;
  }
  
  .valour_text_3 {
    font-size: 18px;
    line-height: 22px; /* 160% */
  }  

}











@media screen and (max-width: 600px) {

  .valour_wrapper {
    width: 100%;
    height: 260px;
    margin: 30px 0 30px 0;
  }
  
  .valour_slider_main {
    width: 100%;
    height: 100%;
  }

  .valour_card > img {
    height: 260px;
  }
  
  .valpour_text_div {
    width: 100% !important;
    height: 100%;
  }
  
  .valour_text_inner_div {
      width: 85%;
      margin-left: 20px;
  }
  
  .valour_text_1 {
    font-size: 30px;
    line-height: 36px;
  }
  
  .valour_text_2 {
    font-size: 18px;
    line-height: 22px;
    margin: 2px 0 2px 0;
  }
  
  .valour_text_3 {
    font-size: 16px;
    line-height: 20px; /* 160% */
  }  

}










@media screen and (max-width: 450px) {

  .valour_wrapper {
    width: 100%;
    height: 220px;
    margin: 30px 0 30px 0;
  }
  
  .valour_slider_main {
    width: 100%;
    height: 100%;
  }

  .valour_card > img {
    height: 220px;
  }
  
  .valpour_text_div {
    width: 100% !important;
    height: 100%;
  }
  
  .valour_text_inner_div {
      width: 90%;
      margin-left: 20px;
  }
  
  .valour_text_1 {
    font-size: 26px;
    line-height: 32px;
  }
  
  .valour_text_2 {
    font-size: 18px;
    line-height: 22px;
    margin: 2px 0 2px 0;
  }
  
  .valour_text_3 {
    font-size: 16px;
    line-height: 20px; /* 160% */
  }  

}`, "",{"version":3,"sources":["webpack://./src/components/homePage/valour/valour.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,6CAA6C;EAC7C,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;AAChC;;;;;;;;;;;AAWA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;MACI,UAAU;MACV,iBAAiB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,SAAS;EAC9B;;AAEF;;;;;;;;;;;;;AAaA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;MACI,UAAU;MACV,iBAAiB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,SAAS;EAC9B;;AAEF;;;;;;;;;;;;;;;AAeA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;MACI,UAAU;MACV,iBAAiB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,SAAS;EAC9B;;AAEF;;;;;;;;;;;;AAYA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;MACI,UAAU;MACV,iBAAiB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,SAAS;EAC9B;;AAEF;;;;;;;;;;;AAWA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;MACI,UAAU;MACV,iBAAiB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,SAAS;EAC9B;;AAEF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap\");\n\n.valour_wrapper {\n  width: 100%;\n  height: 498px;\n  position: relative;\n  margin: 100px 0 137px 0;\n  overflow: hidden;\n}\n\n.valour_slider_main {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 1;\n  outline: none;\n}\n\n.valour_card {\n  width: 100%;\n  height: 100% !important;\n}\n\n.valour_card > img {\n  width: 100%;\n  height: 498px;\n  outline: none;\n  object-fit: cover;\n}\n\n.valour_overlay {\n  width: 100% !important;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  z-index: 2;\n}\n\n.valpour_text_div {\n  width: 100% !important;\n  height: 100%;\n  position: absolute;\n  z-index: 3;\n  display: flex;\n  align-items: center !important;\n}\n\n.valour_text_inner_div {\n    width: 591px;\n    margin-left: 60px;\n}\n\n.valour_text_1 {\n  color: #fff;\n  font-family: Inter;\n  font-size: 52px;\n  font-style: normal;\n  font-weight: 900;\n  line-height: normal;\n}\n\n.valour_text_2 {\n  color: #139719;\n  font-family: \"Open Sans\";\n  font-size: 30px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin: 10px 0 24px 0;\n}\n\n.valour_text_3 {\n  color: #fff;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-family: \"Open Sans\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 38.4px; /* 160% */\n}\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n\n  .valour_wrapper {\n    width: 100%;\n    height: 450px;\n    margin: 50px 0 50px 0;\n  }\n  \n  .valour_slider_main {\n    width: 100%;\n    height: 100%;\n  }\n\n  .valour_card > img {\n    height: 450px;\n  }\n  \n  .valpour_text_div {\n    width: 100% !important;\n    height: 100%;\n  }\n  \n  .valour_text_inner_div {\n      width: 50%;\n      margin-left: 60px;\n  }\n  \n  .valour_text_1 {\n    font-size: 50px;\n    line-height: 56px;\n  }\n  \n  .valour_text_2 {\n    font-size: 26px;\n    line-height: 32px;\n    margin: 10px 0 16px 0;\n  }\n  \n  .valour_text_3 {\n    font-size: 24px;\n    line-height: 30px; /* 160% */\n  }  \n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n\n  .valour_wrapper {\n    width: 100%;\n    height: 400px;\n    margin: 50px 0 50px 0;\n  }\n  \n  .valour_slider_main {\n    width: 100%;\n    height: 100%;\n  }\n\n  .valour_card > img {\n    height: 400px;\n  }\n  \n  .valpour_text_div {\n    width: 100% !important;\n    height: 100%;\n  }\n  \n  .valour_text_inner_div {\n      width: 50%;\n      margin-left: 20px;\n  }\n  \n  .valour_text_1 {\n    font-size: 40px;\n    line-height: 46px;\n  }\n  \n  .valour_text_2 {\n    font-size: 22px;\n    line-height: 26px;\n    margin: 4px 0 6px 0;\n  }\n  \n  .valour_text_3 {\n    font-size: 22px;\n    line-height: 26px; /* 160% */\n  }  \n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n\n  .valour_wrapper {\n    width: 100%;\n    height: 320px;\n    margin: 50px 0 50px 0;\n  }\n  \n  .valour_slider_main {\n    width: 100%;\n    height: 100%;\n  }\n\n  .valour_card > img {\n    height: 320px;\n  }\n  \n  .valpour_text_div {\n    width: 100% !important;\n    height: 100%;\n  }\n  \n  .valour_text_inner_div {\n      width: 70%;\n      margin-left: 20px;\n  }\n  \n  .valour_text_1 {\n    font-size: 36px;\n    line-height: 42px;\n  }\n  \n  .valour_text_2 {\n    font-size: 20px;\n    line-height: 24px;\n    margin: 4px 0 6px 0;\n  }\n  \n  .valour_text_3 {\n    font-size: 18px;\n    line-height: 22px; /* 160% */\n  }  \n\n}\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n  .valour_wrapper {\n    width: 100%;\n    height: 260px;\n    margin: 30px 0 30px 0;\n  }\n  \n  .valour_slider_main {\n    width: 100%;\n    height: 100%;\n  }\n\n  .valour_card > img {\n    height: 260px;\n  }\n  \n  .valpour_text_div {\n    width: 100% !important;\n    height: 100%;\n  }\n  \n  .valour_text_inner_div {\n      width: 85%;\n      margin-left: 20px;\n  }\n  \n  .valour_text_1 {\n    font-size: 30px;\n    line-height: 36px;\n  }\n  \n  .valour_text_2 {\n    font-size: 18px;\n    line-height: 22px;\n    margin: 2px 0 2px 0;\n  }\n  \n  .valour_text_3 {\n    font-size: 16px;\n    line-height: 20px; /* 160% */\n  }  \n\n}\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n  .valour_wrapper {\n    width: 100%;\n    height: 220px;\n    margin: 30px 0 30px 0;\n  }\n  \n  .valour_slider_main {\n    width: 100%;\n    height: 100%;\n  }\n\n  .valour_card > img {\n    height: 220px;\n  }\n  \n  .valpour_text_div {\n    width: 100% !important;\n    height: 100%;\n  }\n  \n  .valour_text_inner_div {\n      width: 90%;\n      margin-left: 20px;\n  }\n  \n  .valour_text_1 {\n    font-size: 26px;\n    line-height: 32px;\n  }\n  \n  .valour_text_2 {\n    font-size: 18px;\n    line-height: 22px;\n    margin: 2px 0 2px 0;\n  }\n  \n  .valour_text_3 {\n    font-size: 16px;\n    line-height: 20px; /* 160% */\n  }  \n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
